import React from 'react'

export const useSurveyBrandAccountQueryKey = (surveyId: string | undefined) =>
  React.useMemo(
    () => ['UseSurveyBrandAccountQuery_Main', { surveyId }],
    [surveyId],
  )
